import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  root: {
    '& svg': {
      width: '16px',
      height: '16px',
      fontSize: '1.0714285714285714rem'
    }
  },
  checked: {
    color: '#004C6A !important',
  }
});

// Inspired by blueprintjs
const StyledCheckbox = (props) => {
  const classes = useStyles();

  return (
    <Checkbox
      classes={{
       root: classes.root,
       checked: classes.checked
      }}
      color="default"
      {...props}
    />
  );
}

export default StyledCheckbox;